import { useStaticQuery } from 'gatsby'
import React from 'react'
import PlantCard from './PlantCard'

export default () => {
  const data = useStaticQuery(query)

  const compareTitles = ( a, b ) => {
    if ( a?.frontmatter?.title < b?.frontmatter?.title){
      return -1;
    }
    if ( a?.frontmatter?.title > b?.frontmatter?.title){
      return 1;
    }
    return 0;
  }
  

  return (
    <>
      {data.allMdx.nodes?.sort(compareTitles)?.map((n, i) => (
        <PlantCard
          key={i}
          title={n?.frontmatter?.title}
          description={n?.frontmatter?.description}
          to={n.slug}
          fluid={n?.frontmatter?.cover?.childImageSharp.fluid}
          tags={n?.frontmatter?.tags}
        />
      ))}
    </>
  )
}

const query = graphql`
  query PlantIndex {
    allMdx(filter: { slug: { regex: "/plants//" } }) {
      nodes {
        slug
        frontmatter {
          description
          title
          tags
          cover {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
        }
      }
    }
  }
`
